/* eslint-disable no-unused-expressions */
// eslint-disable-next-line no-unused-vars
import { numeral } from '@fund/basic-lib';
import { hold as config } from '../config';
// 格式化'%'时不自动除100
numeral.options.scalePercentBy100 = false;

// 持仓（饼图）- 基金持仓 - 资产
export default {

  // 格式化数据
  formatData: (row, typeName) => {
    let data = [];

    let all = 0;
    const setting = config.type[typeName];
    // eslint-disable-next-line array-callback-return
    row.Datas.length && setting.assetList.map((c) => {
      const value = row.Datas[0][c.key];
      if (!value || value === '--') return;
      all += (value - 0);
      data = data.concat([
        {
          name: c.name,
          percent: value - 0,
          a: '1',
        },
      ]);
    });

    if (data.length === 0) {
      data = [{
        name: '无数据',
        percent: 1,
        a: '1',
      }];
    }
    return { data, all };
  },

  // 绘制走势图
  drawChart(data, chart, typeName = '资产') {
    const colors = [];
    const setting = config.type[typeName];
    const noData = data[0].name === '无数据';

    // 数据类型固定颜色
    data.map((d) => colors.push(setting.assetColor[d.name]));

    // 绘制走势图
    chart.source(data);

    chart.scale('value', {
      tickCount: 6,
    });

    chart.legend(false);
    chart.tooltip(false);

    chart.coord('polar', {
      transposed: true,
      innerRadius: 0.75,
      radius: 0.9,
    });
    chart.axis(false);

    chart.source(data, {
      percent: {
        formatter: function formatter() {
          return '';
        },
      },
    });

    chart.interval()
      .position('a*percent')
      .color('name', noData ? ['#ccc'] : colors)
      .adjust('stack')
      .style({
        lineWidth: 1,
        stroke: '#fff',
      })
      .animate(false);

    chart.render();
  },
};
